import logo from './logo.svg';
import './App.css';
import UnSubscribePage from './unSubscribePage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Error404 from './error';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<UnSubscribePage />}> */}
          <Route path="/unsubscribe" element={<UnSubscribePage />} />
          {/* </Route> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
